import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const SearchTranslations = wrapTranslationsSchema({
	name: 'SearchTranslations',
	title: 'Search Translations',
	sanityId: 'search',
	fields: {
		placeholder: 'Search for something...',
		storesPlaceholder: 'Search for a Store by name or description',
		noResults: 'No results',
		countOne: ' {count} result for',
		countOther: ' {count} results for',
		numberOfResults: '{count} of {total} results',
		sortOptionsLabel: 'Sort by',
		sortOptionsRelevance: 'Relevance',
		sortOptionsAlphabeticalAsc: 'Alphabet (A - Z)',
		sortOptionsAlphabeticalDesc: 'Alphabet (Z - A)',
		sortOptionsPopularity: 'Popularity',
		sortOptionsPublishDate: 'Publish date',
		sortOptionsNumberOfVotes: 'Number of votes',
		sortOptionsLastVoteTimestamp: 'Most recently voted',
		filtersTitle: 'Filters',
		filtersClearButton: 'Clear Filters',
		filtersEmptyMessage: 'No Filters',
		filtersShowMoreButton: 'Show More',
		filtersShowLessButton: 'Show Less',
		filtersPlaceholder: 'Search...',
		viewResults: 'View Results',
		feedbackTitle: 'Expected item not found',
		feedbackDidNotFind: 'Did not find what you are looking for?',
		feedbackProvideSuggestion: 'Provide Suggestion',
		cardFulfillmentTime: 'Fulfillment time:',
		cardViewDetails: 'View details',
		cardNew: 'NEW',
		cardGroupedItemsCount: '{count} items',
		suggestionsSearchResultsTitle: 'Search results',
		suggestionsRecentSearchesTitle: 'Recent searches',
		suggestionsSuggestedSearchesTitle: 'Suggested searches',
		suggestionsGroupingSearchesTitle: 'Found in',
		backToSearchResult: 'Back to search results',
		modeProducts: 'Digital, Goods, Service, Catalog',
		modeSuppliers: 'Suppliers',
		modeStores: 'Stores',
		gridView: 'Grid',
		listView: 'List',
		storesPageTitle: 'Stores',
		storesPageSearchPlaceholder: 'Search...',
	},
});
